import { __extends as r } from "./index11.js";
import { Stats as i } from "./index42.js";
import { CoreContext as m } from "./index43.js";
import { ContextCancelation as p } from "./index43.js";
var a = (
  /** @class */
  function(e) {
    r(t, e);
    function t(n, o) {
      return e.call(this, n, o, new i()) || this;
    }
    return t.system = function() {
      return new this({ type: "track", event: "system" });
    }, t;
  }(m)
);
export {
  a as Context,
  p as ContextCancelation
};
//# sourceMappingURL=index14.js.map
